var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", [
      _c("div", { staticClass: "container has-text-centered" }, [
        _c("div", { staticClass: "custom-centered" }, [
          _c("img", {
            staticClass: "logo",
            attrs: {
              src: require("@/assets/gps_logo.png"),
              alt: "Main logo",
              height: "400",
            },
          }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }